import styled, { css } from "styled-components/native";
import { Picker } from "react-native";

import { TextInput } from "components";
import { pickStyle as _, pickThemeKey as theme, flexRow } from "utils";
import {
  ContainerWidth,
  ContainerMarginBottom,
  InputPadding,
} from "./variables";
import { ThemeColors } from "react-navigation";

export const Container = styled.View`
  width: ${_(ContainerWidth) || "100%"};
  margin: 0 auto ${_(ContainerMarginBottom) || 50}px;
  flex-direction: ${flexRow()};
  ${theme("themeWhite")};
  background-color: ${props =>
    props.$hasError ? theme("themeRed")(props) : theme("themeWhite")(props)};
  align-items: flex-end;
  border-radius: 3px;
  border-bottom-width: 5px;
  border-top-width: ${props => (props.$hasError ? 2 : 0)}px;
  border-left-width: ${props => (props.$hasError ? 2 : 0)}px;
  border-right-width: ${props => (props.$hasError ? 2 : 0)}px;
  border-style: solid;
  border-top-color: ${props =>
    props.$hasError ? theme("themeLightRed")(props) : "transparent"};
  border-left-color: ${props =>
    props.$hasError ? theme("themeLightRed")(props) : "transparent"};
  border-right-color: ${props =>
    props.$hasError ? theme("themeLightRed")(props) : "transparent"};
  border-bottom-color: ${props =>
    props.$hasError
      ? theme("themeLightRed")(props)
      : props.$isFocused
      ? theme("open_ended_borders")(props)
      : theme("open_ended_borders_inactive")(props)};
  ${props =>
    props.$RTL
      ? css`
          padding-right: 10px;
        `
      : css`
          padding-left: 10px;
        `}
`;

export const Wrapper = styled.View`
  background-color: ${theme("themeWhite")};
  flex: 1;
`;

export const DialCode = styled.View`
  flex-direction: row;
  border-radius: 5px;
  background-color: ${theme("themeLightestGrey")};
  padding: 4px;
  height: 26px;
  align-items: center;
  margin-bottom: 12px;
`;

export const CountryPicker = styled(Picker)`
  opacity: 0;
  position: absolute;
`;

export const CountryPickerItem = styled(Picker.Item)``;

export const CountryFlag = styled.Image`
  width: 18px;
  height: 20px;
  resize-mode: contain;
  margin-right: 4px;
`;

export const CountryCodeText = styled.Text`
  font-size: 12px;
  font-weight: 600;
`;

export const Label = styled.Text`
  color: ${props =>
    props.$isFocused
      ? theme("themeBlack")(props)
      : theme("themeLightGrey")(props)};
  font-size: ${props => (props.$isFocused ? "13" : "18")}px;
  position: absolute;
  top: ${props => (props.$isFocused ? "1" : "22")}px;
  ${props =>
    props.$RTL
      ? css`
          right: ${p => (p.$isFocused ? "-60" : "18")}px;
        `
      : css`
          left: ${p => (p.$isFocused ? "-60" : "18")}px;
        `}
`;

export const StyledTextInput = styled(TextInput)`
  padding: ${_(InputPadding) || " 22px 11px 15px"};
  background-color: ${props =>
    props.$hasError ? theme("themeRed")(props) : theme("themeWhite")(props)};
  border-radius: 3px;
  width: 100%;
  border: 0;
  font-size: ${theme("other_text_size") || 20}px;
  color: ${theme("open_ended_text")};
`;
